<div class="setting-page">
  <legend>Remote Manager</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="false" [validateForm]="false">
    <arm-form-title>OVOC Server</arm-form-title>
    <div class="settings-section">

      <div>
      <mat-slide-toggle color="primary"
                        [checked]="remoteManager.isAlarmForwardingEnabled"
                        (change)="remoteManager.isAlarmForwardingEnabled = $event.checked">
        Enable Alarms/Events forwarding
      </mat-slide-toggle>
      </div>

      <mat-slide-toggle color="primary"
                        [checked]="remoteManager.isJournalForwardingEnabled"
                        (change)="remoteManager.isJournalForwardingEnabled = $event.checked">
        Enable Journal forwarding
      </mat-slide-toggle>

      <mat-form-field class="fullWidth">
        <mat-label>Host</mat-label>
        <input [(ngModel)]="remoteManager.host" matInput name="host" disabled>
      </mat-form-field>

      <mat-form-field class="fullWidth">
        <mat-label>HTTP Port</mat-label>
        <input type="number" [(ngModel)]="remoteManager.httpPort" matInput name="port" disabled>
      </mat-form-field>

      <mat-form-field class="fullWidth">
        <mat-label>HTTPS Port</mat-label>
        <input type="number" [(ngModel)]="remoteManager.httpsPort" matInput name="https-port" disabled>
      </mat-form-field>

      <ac-input-container label="Security mode" class="fullWidth">
        <ac-select [acModel]="remoteManager.securityMode"
                   [searchable]="false"
                   [ngDisabled]="true"
                   (acModelChange)="remoteManager.securityMode = $event"
                   [items]="securityMode"
                   [bindValue]="'value'"
                   [bindLabel]="'label'">
        </ac-select>
      </ac-input-container>

      <mat-form-field class="fullWidth">
        <mat-label>User name</mat-label>
        <input [(ngModel)]="remoteManager.username" matInput name="username" disabled>
      </mat-form-field>
    </div>
  </arm-form>
</div>
